import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;
export class ZIDXAccountSiteDesign implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSiteDesignContainer";
    }
    render(){
        // console.log("site design");
        let self=this;
        this.updateForm();
        $(".zidxAccountSiteDesignContainer input[name='idx_site_design_style']", this.zidx.peakidxShadowRoot).on("change", function(this:Element, e: JQuery.Event) {
            self.updateForm();
        });
        $(".zidxAccountSiteDesignContainer input[name='headerLayout']", this.zidx.peakidxShadowRoot).on("change", function(this:Element, e: JQuery.Event) {
            self.updateForm();
        });
        $(".zidxAccountSiteDesignContainer input[name='footerLayout']", this.zidx.peakidxShadowRoot).on("change", function(this:Element, e: JQuery.Event) {
            self.updateForm();
        });
    }
    updateForm(){
        let formData=this.zidx.getFormDataByFormId($(".zidxAccountSiteDesignContainer .zidxForm", this.zidx.peakidxShadowRoot)[0].id);
        let theme=formData["idx_site_design_style"];
        if(theme=="2") {
            $(".zidxAccountSiteDesignContainer .siteDesignColorsAccordion", this.zidx.peakidxShadowRoot).show();
        }else{
            $(".zidxAccountSiteDesignContainer .siteDesignColorsAccordion", this.zidx.peakidxShadowRoot).hide();
        }
        if(formData["headerLayout"]=="custom") {
            $(".zidxAccountSiteDesignContainer #headerCustomHTML_container", this.zidx.peakidxShadowRoot).show();
        }else{
            $(".zidxAccountSiteDesignContainer #headerCustomHTML_container", this.zidx.peakidxShadowRoot).hide();
        }
        if(formData["footerLayout"]=="custom") {
            $(".zidxAccountSiteDesignContainer #footerCustomHTML_container", this.zidx.peakidxShadowRoot).show();
        }else{
            $(".zidxAccountSiteDesignContainer #footerCustomHTML_container", this.zidx.peakidxShadowRoot).hide();
        }
    }
}